import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { ButtonBlock } from '../../common/ButtonBlock/ButtonBlock';
import { TerraceDesignAlignmentViewVM } from './TerraceDesignAlignmentViewVM';
import stores from 'cd-eft/models/Stores';
import { ActionsMenu } from '../../common/ActionsMenu';
import './TerraceDesignAlignmentView.scss';
import { DynamicAlignmentHub } from 'cd-eft/models/Stores/DynamicProfile/Alignment/DynamicAlignmentHub';
import { DynamicProfileStoreBase } from 'cd-eft/models/Stores/DynamicProfile/DynamicProfileStoreBase';
import { DynamicTableStoreBase } from 'cd-eft/models/Stores/DynamicProfile/DynamicTableStoreBase';
import { EngineeringMapService } from 'cd-eft/framework/mapServices/EngineeringMapServices';
import { ProfileStoreType } from 'cd-eft/models/Stores/DynamicProfile/DynamicProfileEnums';
import { DynamicTerraceProfile } from 'cd-eft/components/common/DynamicProfile/DynamicTerraceProfile';
import { AlignmentTable } from '../../alignment/AlignmentTable/AlignmentTable';
import Draggable from 'react-draggable';
import { ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { UserLeavingWarning } from 'cd-eft/components/common/UserLeavingWarning/UserLeavingWarning';
import { DeleteElement } from '../../common/DeleteElement';
import { Input } from 'cd-eft/components/common/Input';
import { useHistory } from 'react-router-dom';

import arrowCursorMove from 'cd-eft/assets/images/arrow-cursor-move.svg';
import updateCurves from 'cd-eft/assets/images/update-curves.svg';
import applyDefaultCurves from 'cd-eft/assets/images/apply-default-curves.svg';
import { mdiCog, mdiPencil, mdiPlusBoxOutline, mdiTrashCanOutline } from '@mdi/js';

const { designStore, alignmentDesignStore, terraceDesignStore } = stores.AppStore;

export const HydroToolModal = observer(({ vm }: { vm: TerraceDesignAlignmentViewVM }) => {
  return (   
    <Draggable axis="both" positionOffset={{ x: '-50%', y: '-50%' }} cancel="input,select,button">     
     <div className="hydro-modal">
        {vm.loading && <Loader message={''} />}
        <ModalHeader className='hydro-modal-header'>
          <div className="hydro-header-content">Hydro Tool</div>
        </ModalHeader>
        <ModalBody> 
        <div className="hydro-content row "> 
      
          <div className="col hydro-inputs">
              <div className="row col-header">
                <div className="col">Current Runoff</div>
              </div>
             <Input 
                label="Drainage Area (ac)" 
                idAndName="drainageArea" 
                valid={true}
                value={vm.curretRunoffValue.watershedArea}
                className="read-only-box"
                type="string" 
                onChange={()=>{}} 
                readOnly={true}            
              />          
              <Input 
                label="Weighted Curve Number" 
                idAndName="curveNumber" 
                valid={true}
                value={vm.curretRunoffValue.watershedCN}
                className="read-only-box"
                type="string" 
                onChange={()=>{}} 
                readOnly={true}            
              />     
             <Input 
                label="Watershed Length (ft)" 
                idAndName="watershedLength" 
                valid={true}
                value={vm.curretRunoffValue.watershedLength}
                className="read-only-box"
                type="string" 
                onChange={()=>{}} 
                readOnly={true}            
              />           
              <Input 
                label="Watershed Slope (%)" 
                idAndName="watershedSlope" 
                valid={true}
                value={vm.curretRunoffValue.watershedSlope}
                className="read-only-box"
                type="string" 
                onChange={()=>{}} 
                readOnly={true}            
              />     
              <Input 
                label="Runoff (in)" 
                idAndName="runoff" 
                valid={true}
                value={vm.curretRunoffValue.runoffQ}
                className="read-only-box"
                type="string" 
                onChange={()=>{}} 
                readOnly={true}            
              />
              <Input 
                label="Peak Flow Q (cfs)" 
                idAndName="peakFlow" 
                valid={true}
                value={vm.curretRunoffValue.peakFlow}
                className="calculated-result-box"
                type="string" 
                onChange={()=>{}} 
                readOnly={true}            
              />                   
          </div>
          <div className="col hydro-inputs">
          <div className="row col-header">
                <div className="col">New Runoff</div>
              </div>
              <Input
                label="Drainage Area (ac)"
                idAndName="watershedArea"
                valid={!vm.formValidation.watershedArea}
                value={vm.inputForms.watershedArea}
                className={vm.hydroToolErrorClass('watershedArea')}
                type="number"
                step={'0.01'}
                onChange={(e) => vm.handleInputsOnChange(e)} 
                onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                onKeyDown={vm.handleOnKeyDown}
                min={0.01}
              />          
              <Input 
                label="Weighted Curve Number" 
                idAndName="curveNumber" 
                valid={true}
                value={vm.inputForms.watershedCN}
                className="read-only-box"
                type="string" 
                onChange={()=>{}} 
                readOnly={true}            
              />  
              <Input 
                label="Watershed Length (ft)" 
                idAndName="watershedLength" 
                valid={true}
                value={vm.inputForms.watershedLength}
                className="read-only-box"
                type="string" 
                onChange={()=>{}} 
                readOnly={true}            
              />       
             <Input 
                label="Watershed Slope (%)" 
                idAndName="watershedSlope" 
                valid={true}
                value={vm.inputForms.watershedSlope}
                className="read-only-box"
                type="string" 
                onChange={()=>{}} 
                readOnly={true}            
              />   
              <Input 
                label="Runoff (in)" 
                idAndName="runoff" 
                valid={true}
                value={vm.inputForms.runoffQ}
                className="read-only-box"
                type="string"
                onChange={()=>{}} 
                readOnly={true}  
              />
              <Input
                label="Peak Flow Q (cfs)"
                idAndName="peakFlow"
                valid={!vm.formValidation.peakFlow}
                value={vm.inputForms.peakFlow}
                className={vm.hydroToolErrorClass('peakFlow')}
                type="number"
                step={'0.01'}
                onChange={(e) => vm.handleInputsOnChange(e)} 
                onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                onKeyDown={vm.handleOnKeyDown}
                min={0.01}
              />          
          </div>      
        </div>  
        
        </ModalBody>
        <ModalFooter>
          <div className="drain-buttons">
            <button className="usa-button usa-button--outline close-button" onClick={vm.onCancel}>
              Close
            </button>
            <button className="usa-button save-button" onClick={vm.calculateHydro} disabled={Number(vm.inputForms.watershedArea) === Number(vm.curretRunoffValue.watershedArea) || vm.calculationPerformed || vm.isPeakFlowManuallyEdited}>
              Calculate
            </button>
            <button className="usa-button save-button" onClick={vm.saveHydro} disabled={Object.values(vm.formValidation.formErrors).some(error => error.length > 0) || (!vm.calculationPerformed && !vm.isPeakFlowManuallyEdited) || (Number(vm.inputForms.watershedArea) === Number(vm.curretRunoffValue.watershedArea) && Number(vm.inputForms.peakFlow) === Number(vm.curretRunoffValue.peakFlow))}>
              Save
            </button>
          </div>
        </ModalFooter>
      </div>
    </Draggable>
  );
});

const TerraceDesignAlignmentViewComponent = (props) => {
  const history = useHistory();
  let profileHub: DynamicAlignmentHub;
  const profileStoreRef = useRef<DynamicProfileStoreBase>();
  const profileTableStoreRef = useRef<DynamicTableStoreBase>();

  if (!profileTableStoreRef.current && !profileStoreRef.current) {
    profileHub = new DynamicAlignmentHub(true);
    profileHub.createStore(ProfileStoreType.MAP, { mapView: EngineeringMapService.instance?.mapView });
    profileHub.createStore(ProfileStoreType.PROFILE);
    profileStoreRef.current = profileHub.ProfileStore;
    profileHub.createStore(ProfileStoreType.TABLE);
    profileTableStoreRef.current = profileHub.TableStore;
  }

  const vmREF = useRef<TerraceDesignAlignmentViewVM>();
  if (!vmREF.current) {
      vmREF.current = new TerraceDesignAlignmentViewVM(
          {
              ...props,
              tableStoreRef: profileTableStoreRef.current,
              profileStoreRef: profileStoreRef.current,
              history: history
          },
      );
  }

  const vm = vmREF.current;

  useEffect(() => {
    vm.onMount();
    function unmount() {
      alignmentDesignStore.reset();
      vm.removeAlignmentSketch();
      vm.unMount();
    }
    return unmount;
  }, []);

  // ************** Profile Setup ************** //
  // Need to check if UI is fully rendered before drawing profile
  const [uiReady, setUiReady] = useState(false);
  const alignmentContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    vm.userLeavingWarningIsShown = false;
    const checkDimensions = () => {
      if (alignmentContainerRef.current) {
        const { width, height } = alignmentContainerRef.current.getBoundingClientRect();

        if (width > 0 && height > 0) {
          setUiReady(true);
          return;
        }
      }
  
      requestAnimationFrame(checkDimensions);
    };

    if (terraceDesignStore.alignmentDesignElementJsonId) {
      vm.init();
      checkDimensions();
    }
  }, [terraceDesignStore.alignmentDesignElementJsonId]);
  // ************ End Profile Setup ************ //

  useEffect(() => {
    if(vm.redirectToProfile) history.push(`/design/${designStore.projectsStore.currentProject.projectUuid}/terrace/${terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId}/design`);
  }, [vm.redirectToProfile, history])

  
  return (
    <>
      <div ref={alignmentContainerRef} id="separator-top-container">
        {/* *****Profile****** */}
        <Accordion
          key={`terrace-profile-tab-content-alignment-view`}
          className="accordion-wrapper profile-info"
          headers={['Alignment View']}
          expanded={true}
          light={true}
          actionButton={
            <ActionsMenu item="item" elementActions={vm.setProfileViewActions()} disabled={true}>
              Action
            </ActionsMenu>
          }
          onToggle={vm.removeHeights}
        >
          <>
            <DynamicTerraceProfile profileStore={profileStoreRef.current} editable={false} generateInitialProfiles={vm.generateProfiles} uiReady={uiReady} />
            <ButtonBlock buttons={[
              { icon: mdiPencil, title: 'Hydro Tool', disabled: vm.disableHydroTool, onClick: () => vm.openHydroTool(), className: 'ml-0'},
              { icon: mdiCog, title: 'Settings', disabled: false, onClick: () => { }, className: 'mr-auto hidden'},
              {
                icon: mdiPlusBoxOutline,
                title: 'Insert Station',
                disabled: false,
                onClick: vm.insertStation,
              },
              {
                img: arrowCursorMove,
                title: 'Move Station',
                alt: '',
                disabled: false,
                onClick: vm.moveStation,
                imgClassName: true ? 'arrowCursorMove' : 'mr-2 arrowCursorMoveDisabled',
              },
              {
                icon: mdiTrashCanOutline,
                title: 'Delete Station',
                disabled: false,
                onClick: vm.deleteStation,
              },
              {
                img: applyDefaultCurves,
                imgClassName: 'mr-2',
                title: 'Apply Default Curve',
                disabled: false,
                onClick: vm.applyDefaultCurves,
              },
              {
                img: updateCurves,
                imgClassName: 'mr-2',
                title: 'Update Curves',
                disabled: false,
                onClick: vm.updateCurves,
              },
            ]} />
          </>
        </Accordion>
      </div>
        {vm.showHydroToolModal && <HydroToolModal vm={vm}/>}
      <div id="separator"></div>
       
      <div id="separator-bottom-container">
        {/* *****Table****** */}
        <Accordion
          className="accordion-wrapper results-info pb-0"
          headers={['Alignment Stations Table']}
          expanded={true}
          light={true}
          onToggle={vm.removeHeights}
        >
          <AlignmentTable
            currentObject={alignmentDesignStore.alignmentObject}
            handleRowMouseEnter={vm.handleRowMouseEnter}
            handleRowMouseLeave={vm.handleRowMouseLeave}
            updateSingleAlignmentStation={vm.updateSingleAlignmentStation}
            updateMapAndProfile={vm.updateMapAndProfile}
            handleCurveValueInputFocus={vm.handleCurveValueInputFocus}
            vm={vm}
            enableAdvancedFeatures={false}
          />
        </Accordion>
      </div>
      <div className="pr-3 pb-2 border-top">
        <ButtonBlock buttons={[
          { title: 'Close', disabled: false, onClick: vm.closeTerraceAlignment, className: 'usa-button--outline px-4' },
          { title: 'Save', disabled: alignmentDesignStore.disableSaveAlignment, onClick: vm.saveTerraceAlignment, className: 'px-4 mr-0' },
        ]} />
      </div>

      {/* popups  */}
      {vm.majorAlignmentChange && <MajorAlignmentChangeConfirmationModal vm={vm} />}  
      <UserLeavingWarning
        when={vm.userLeavingWarningIsShown}
        section="Terrace Design Alignment View"
        onOK={vm.userLeavingWarningOnOk}
        okText="Return"
        // cancelText="Cancel"
        // onCancel={vm.userLeavingWarningOnCancel}
        text={`You have unsaved changes on Alignment`}
      />

      {alignmentDesignStore.deleteAlStDialoglIsOpen && (
        <DeleteElement
          trigger={alignmentDesignStore.deleteAlStDialoglIsOpen}
          setTrigger={alignmentDesignStore.toggleDeleteAlStDialog}
          element="alignment station"
          name={alignmentDesignStore.alignmentStationToDelete.stationName}
          action={vm.deleteSingleAlignmentStation}
        />
      )}
    </>
  );
};

export const TerraceDesignAlignmentView = observer(TerraceDesignAlignmentViewComponent);

const MajorAlignmentChangeConfirmationModal = observer(({ vm}: { vm: TerraceDesignAlignmentViewVM }) => {
  return (
    <Draggable axis="both" positionOffset={{ x: '-50%', y: '-50%' }} cancel="input,select">
      <div className="major-edit-info-modal">
        <ModalHeader className="model-header">
          <div className="major-edit-info-header">
            Major Edit Detected
          </div>
        </ModalHeader>
        <ModalBody className='major-edit-info-body'>
          <h5>Code: Terrace_18</h5>
          <>{vm.majorAlignmentEditMessage}</>
        </ModalBody>
        <ModalFooter>
          <div className="major-edit-info-buttons">
            <button
              className="usa-button usa-button--outline"
              onClick={(e) => vm.handleMajorAlignmentEdit(e)}
            >
              Continue
            </button>
            <button className="usa-button" onClick={vm.handleCancelMajorAlignmentEdit}>
              Cancel Edit
            </button>
          </div>
        </ModalFooter>
      </div>
    </Draggable>
  );
});
